import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["changeHandler", "innerRef"];
import React, { Component, createRef } from 'react';
import { isFunction } from '../../../utils';

var identityFn = s => s;

var withCursorTracking = (WrappedComponent, demaskFn) => {
  class ComponentWithCursorTracking extends Component {
    constructor(props) {
      var _this;

      super(props);
      _this = this;

      _defineProperty(this, "getNumMaskChars", str => {
        return str.length - this.demaskFn(str).length;
      });

      _defineProperty(this, "changeHandler", function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var [e, newValue, oldValue] = args;
        var {
          value: inputValue
        } = e.target;
        var {
          changeHandler
        } = _this.props;
        var inputEl = _this.inputRef.current;
        var wasLegalCharEntered = newValue.length > oldValue.length;

        var initialMaskChars = inputValue.length - _this.demaskFn(inputValue).length;

        var cursorPos = inputEl.selectionStart;

        if (isFunction(changeHandler)) {
          changeHandler(...args);
        }

        requestAnimationFrame(() => {
          if (document.activeElement !== inputEl) {
            return;
          }

          var {
            value: updatedValue
          } = inputEl;
          var updatedMaskChars = updatedValue.length - _this.props.value.length;
          var additionalMaskChars = updatedMaskChars - initialMaskChars;

          if (wasLegalCharEntered && additionalMaskChars > 0) {
            var adjCursorPos = cursorPos + additionalMaskChars;
            var valueAfterCursor = inputValue.slice(cursorPos);

            var maskCharsAfterCursor = _this.getNumMaskChars(valueAfterCursor);

            var updatedValueAfterCursor = updatedValue.slice(adjCursorPos);

            var updatedMaskCharsAfterCursor = _this.getNumMaskChars(updatedValueAfterCursor);

            cursorPos = adjCursorPos - updatedMaskCharsAfterCursor + maskCharsAfterCursor;
          }

          inputEl.setSelectionRange(cursorPos, cursorPos);
        });
      });

      this.demaskFn = isFunction(demaskFn) ? demaskFn : identityFn;
      this.inputRef = props.innerRef || createRef(this, 'inputRef');
    }

    render() {
      var _this$props = this.props,
          {
        changeHandler,
        innerRef
      } = _this$props,
          rest = _objectWithoutProperties(_this$props, _excluded);

      return React.createElement(WrappedComponent, _extends({
        changeHandler: this.changeHandler,
        ref: this.inputRef
      }, rest));
    }

  }

  return ComponentWithCursorTracking;
};

export { withCursorTracking };